export const LOCALES = {
    ENGLISH: 'en',
    GERMAN: 'de',
    FRENCH: 'fr',
    ARABIC: 'ar',
    ITALIEN: 'it',
    PORTUG: 'pt',
    CHINESE: 'cn',
    UKRAINE: 'uk',
    URDU: 'ur',
};
